import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User created anonymous account',
  name: 'created_anonymous_account',
  params: [
    {
      description: 'Location of the event',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['clip-share-link', 'board-share-link', 'content-collection', 'custom-field-change', 'comment-addition'],
    },
    {
      description: 'Id of an object that share link is generated for',
      name: 'object_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Type of an object that share link is generated for',
      name: 'object_type',
      required: true,
      type: 'enum',
      values: ['board', 'clip'],
    },
    {
      description: 'Generated share url',
      name: 'share_url',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
